import { Col, Row } from '@/components/grid/grid-component';
import styled from 'styled-components';

const RowStyle = styled(Row)`
  width: 100% !important;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK} !important;
  margin-bottom: 25px !important;
  padding: 24px !important;
  margin-right: 0px !important;
  margin-left: 0px !important;
  justify-content: end !important;
`;

const Main = styled.div`
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  min-height: 100%;
  justify-content: center;
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;
const StyledCol = styled(Col)`
  max-width: '91%';
  width: '100%';
`;

const GoBack = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
`;

const companyNewStyle = {
  RowStyle,
  Main,
  Container,
  StyledCol,
  GoBack,
};

export default companyNewStyle;
